import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../api/auth';
import AuthNavbar from '../components/layout/AuthNavbar';

export default function ForgotPasswordPage() {
  const [email, setEmail]     = useState('');
  const [sent, setSent]       = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    const trimmed = email.trim();
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(trimmed);
    if (!emailOk) { setError('Please enter a valid email address (e.g. you@example.com).'); return; }
    setLoading(true);
    try {
      await authApi.forgotPassword(trimmed);
      setSent(true);
    } catch {
      // Always show success to prevent email enumeration on the existence check
      setSent(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <AuthNavbar />
      <div style={styles.bg}>
      <div style={styles.card}>
        <div style={styles.logo}>Inverow</div>

        {sent ? (
          <>
            <div style={styles.successIcon}>✉️</div>
            <h1 style={styles.title}>Check your email</h1>
            <p style={styles.sub}>
              If an account exists for <strong>{email}</strong>, we've sent a password reset link. Check your inbox (and spam folder).
            </p>
            <Link to="/login" style={styles.backLink}>← Back to sign in</Link>
          </>
        ) : (
          <>
            <h1 style={styles.title}>Reset password</h1>
            <p style={styles.sub}>Enter your email and we'll send you a reset link.</p>

            {error && <div style={styles.error}>{error}</div>}

            <form onSubmit={handleSubmit} style={styles.form}>
              <label style={styles.label}>Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                style={styles.input}
                autoComplete="email"
              />
              <button type="submit" disabled={loading} style={{ ...styles.btn, marginTop: '20px' }}>
                {loading ? 'Sending…' : 'Send reset link'}
              </button>
            </form>

            <p style={styles.foot}>
              <Link to="/login" style={styles.link}>← Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
    </>
  );
}

const styles = {
  bg: { minHeight: 'calc(100vh - 71px)', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: '24px' },
  card: { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '20px', padding: '40px 36px', width: '100%', maxWidth: '420px', boxShadow: 'var(--shadow)' },
  logo: { fontSize: '22px', fontWeight: 800, color: 'var(--accent)', marginBottom: '24px', letterSpacing: '-0.5px' },
  title: { fontSize: '24px', fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 6px' },
  sub: { fontSize: '14px', color: 'var(--text-secondary)', margin: '0 0 28px', lineHeight: 1.6 },
  successIcon: { fontSize: '40px', marginBottom: '16px' },
  error: { background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '10px', padding: '12px 14px', color: '#ef4444', fontSize: '14px', marginBottom: '20px' },
  form: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: 600, color: 'var(--text-secondary)', marginTop: '10px' },
  input: { padding: '12px 14px', borderRadius: '10px', border: '1px solid var(--border)', background: 'var(--surface-strong)', color: 'var(--text-primary)', fontSize: '15px', outline: 'none', boxSizing: 'border-box' },
  link: { color: 'var(--accent)', textDecoration: 'none', fontSize: '13px', fontWeight: 600 },
  backLink: { display: 'inline-block', color: 'var(--accent)', textDecoration: 'none', fontSize: '14px', fontWeight: 600, marginTop: '8px' },
  btn: { padding: '13px', borderRadius: '12px', border: 'none', background: '#6366f1', color: '#ffffff', fontSize: '15px', fontWeight: 700, cursor: 'pointer', width: '100%' },
  foot: { textAlign: 'center', fontSize: '14px', color: 'var(--text-secondary)', marginTop: '24px', marginBottom: 0 },
};
